import { Route as OutOfStockRoute } from "@/routes/(inventory)/branch/_layout/reports/out-of-stock/index";
import { useQuery } from "@tanstack/react-query";
import { getOutOfStock } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useOutOfStockData = () => {
  const searchParams = OutOfStockRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["out-of-stock", searchParams],
    queryFn: async () => {
      const response = await getOutOfStock(
        searchParams.page || 1,
        searchParams.pageSize || 10,
        searchParams.type
      );
      return {
        items: response.items,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};